import React, {useState} from "react";
import {Trans, useTranslation} from "react-i18next";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import Link from "@awsui/components-react/link";
import SpaceBetween from "@awsui/components-react/space-between";
import NavigationBar from "components/NavigationBar";
import {useAuth} from "hooks/useAuth";
import {useQuery} from "react-query";
import Competition from "model/Competition";
import getCompetitions from "api/getCompetitions";
import Spinner from "@awsui/components-react/spinner";
import {CompetitionState} from "model/CompetitionState";


const HomePage: React.FC = () => {

    const {t} = useTranslation("home");
    const [{isSignedIn, user}] = useAuth();
    const [openCompetitions, setOpenCompetitions] = useState<Competition[]>([]);

    const {
        isLoading: competitionsIsLoading
    } = useQuery<Competition[], Error>("getCompetitions", () => getCompetitions(user?.token), {
        enabled: isSignedIn,
        onSuccess: (comps) => {
            const openCompetitions = comps.filter(competition => (
                competition.state === CompetitionState.NOT_STARTED
            ));
            setOpenCompetitions(openCompetitions);
        },
        refetchOnWindowFocus: true
    });

    return (
        <SpaceBetween size="l">
            <NavigationBar/>
            <Container
                variant="default"
                header={
                    <Header variant="h2">
                        {user ? t("welcomeTitle", {name: `${user.name}!`}) : t("welcomeTitleAnonymous")}
                    </Header>
                }
            >
                {t("welcomeBody")}
            </Container>
            <Container
                variant="default"
                header={
                    <Header variant="h2">{t("aboutTitle")}</Header>
                }
            >
                <Trans
                    t={t}
                    i18nKey="aboutIntro"
                    components={[<Link variant={"primary"} href={"/about"}>about</Link>]}
                />
                {isSignedIn && (
                    <>
                        {" "}
                        <Trans
                            t={t}
                            i18nKey="aboutSignedIn"
                            components={[
                                <Link variant={"primary"} href={"/standings"}>standings</Link>,
                                <></>,
                                <Link variant={"primary"} href={"/lineup"}>lineup</Link>,
                                <></>,
                                <Link variant={"primary"} href={"/questions"}>questions</Link>,
                                <></>,
                                <Link variant={"primary"} href={"/stats"}>stats</Link>,
                                <></>,
                                <Link variant={"primary"} href={"/leagues"}>leagues</Link>
                            ]}
                        />
                    </>
                )}
            </Container>
            {isSignedIn && (
                <Container
                    variant="default"
                    header={
                        <Header variant="h2">{t("openCompetitionsTitle")}</Header>
                    }
                >
                    {competitionsIsLoading ? (
                        <Spinner size="big"/>
                    ) : (
                        (openCompetitions && openCompetitions.length > 0) ? (
                            t("openCompetitions", {
                                count: openCompetitions.length,
                                names: openCompetitions.map(c => c.name).join(", ")
                            })
                        ) : (
                            t("noOpenCompetitions")
                        )
                    )}
                </Container>
            )}
        </SpaceBetween>
    );
};

export default HomePage;
